import React, { useState } from "react";
import "./ImageGrid.css"; // Import your CSS file
import GK21 from "../Images/GK2/GK 2 __2nd pictures option _ Webp format.webp";
import GK22 from "../Images/GK2/GK 2 __Webp format.webp";
import GK23 from "../Images/GK2/awlrt9ikb1er0vrz9xrq.webp";
import GK24 from "../Images/GK2/fyyfukc1m1ji4ffbyiam.webp";
import GK25 from "../Images/GK2/hzfmppc7xthcxivupqhb.webp";
import GK26 from "../Images/GK2/mnq9uzcihgg2ye87bt7w.webp";
import GK27 from "../Images/GK2/rdagq0ehbyliwz6qhxh3.webp";
import GK28 from "../Images/GK2/wnsfquxbuiw6locrgcmh.webp";
import GK29 from "../Images/GK2/yevqfjz1qp6sjujtao93.webp";
import GK210 from "../Images/GK2/hysfhzwbwscvr1mj1z2x.webp";

const ImageGrid = () => {
  const [selectedImage, setSelectedImage] = useState(null);

  const images = [GK21, GK22, GK23, GK24, GK25, GK26, GK27, GK28, GK29, GK210];

  const handleImageClick = (image) => {
    setSelectedImage(image);
  };

  const handleCloseCarousel = () => {
    setSelectedImage(null);
  };

  const handleNextImage = () => {
    const currentIndex = images.indexOf(selectedImage);
    if (currentIndex < images.length - 1) {
      setSelectedImage(images[currentIndex + 1]);
    } else {
      setSelectedImage(images[0]);
    }
  };
  const handlePrevImage = () => {
    const currentIndex = images.indexOf(selectedImage);
    if (currentIndex > 0) {
      setSelectedImage(images[currentIndex - 1]);
    }
  };
  return (
    <div className="ui1">
      <div className="ui2">
        <div className="ui3">
          {images.slice(0, 5).map((image, index) => (
            <div key={index} className="image-container">
              <img
                src={image}
                alt={`Image ${index + 1}`}
                onClick={() => handleImageClick(image)}
              />
            </div>
          ))}
        </div>
        <div className="ui3">
          {images.slice(5).map((image, index) => (
            <div key={index} className="image-container">
              <img
                src={image}
                alt={`Image ${index + 6}`}
                onClick={() => handleImageClick(image)}
              />
            </div>
          ))}
        </div>
      </div>

      {selectedImage && (
        <div className="overl">
          <div className="carousel">
            <button className="close-button" onClick={handleCloseCarousel}>
              <i className="fas fa-times"></i>
            </button>
            <button onClick={handlePrevImage}>
              <i className="fa-solid fa-chevron-left"></i>
            </button>
            <img src={selectedImage} alt="Selected" />
            <button onClick={handleNextImage}>
              <i className="fa-solid fa-chevron-right"></i>
            </button>
          </div>{" "}
        </div>
      )}
    </div>
  );
};
export default ImageGrid;
